import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

const TABS_VARIANTS = ['tabs', 'tabs-justified'];

export default function RadioButton({
  checked,
  id,
  name,
  onChange,
  title,
  subtitle,
  value,
  newDesignSystemStyles,
  variant,
  inputFirst
}) {
  const iconName = checked ? 'radio-on' : 'radio-off';
  const isTabsVariant = TABS_VARIANTS.includes(variant);

  const label = (
    // Tabs variants keep their own spacing; everything else uses the flex gap below
    <div className={classnames({ mr2: isTabsVariant })}>
      <p
        className={classnames({
          pl1: !isTabsVariant && !inputFirst,
          'font-16 secondary': newDesignSystemStyles
        })}
      >
        {title}
      </p>
      {subtitle && <p className="font-16 secondary">{subtitle}</p>}
    </div>
  );

  const input = (
    <RadioButtonInput
      checked={checked}
      id={id}
      name={name}
      onChange={onChange}
      value={value}
      newDesignSystemStyles={newDesignSystemStyles}
      variant={variant}
    />
  );

  return (
    <div className="RadioButton">
      <label
        htmlFor={id}
        className={classnames('flex items-center', {
          'justify-between': variant === 'tabs-justified',
          'gap-8': !isTabsVariant
        })}
      >
        {inputFirst ? input : label}
        {inputFirst ? label : input}
        {isTabsVariant && (
          <Icon name={`fetch-${iconName}`} className="blue-500" />
        )}
      </label>
    </div>
  );
}

RadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool
  ]),
  newDesignSystemStyles: PropTypes.bool,
  variant: PropTypes.string,
  // Renders the radio control before its label, per the deposit policy designs
  inputFirst: PropTypes.bool
};

RadioButton.defaultProps = {
  value: null,
  subtitle: null,
  newDesignSystemStyles: false,
  variant: null,
  inputFirst: false
};

export function RadioButtonInput({
  checked,
  id,
  name,
  onChange,
  value,
  newDesignSystemStyles,
  variant
}) {
  const iconName = checked ? 'radio-on' : 'radio-off';
  const isTabsVariant = TABS_VARIANTS.includes(variant);

  return (
    <div className="RadioButtonInput dib" data-test-id="RadioButtonInput">
      <input
        className="RadioButton__input"
        checked={checked}
        id={id}
        name={name}
        onChange={() => {}}
        onClick={onChange}
        type="radio"
        value={value}
      />
      {!isTabsVariant && (
        <Icon
          name={newDesignSystemStyles ? `fetch-${iconName}` : iconName}
          className={classnames({
            'blue-500': newDesignSystemStyles
          })}
        />
      )}
    </div>
  );
}

RadioButtonInput.propTypes = {
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool
  ]),
  newDesignSystemStyles: PropTypes.bool,
  variant: PropTypes.string
};

RadioButtonInput.defaultProps = {
  value: null,
  newDesignSystemStyles: false,
  variant: null
};
